import React from "react"

/**
 * Reading wallpaper — theme-matched ambient field with slow glow drift.
 */
export default function ReadingScene({ layerRef, active = false }) {
  return (
    <div
      ref={layerRef}
      className={`reading-wallpaper fixed inset-0 pointer-events-none z-[1] overflow-hidden${
        active ? " reading-wallpaper--active" : ""
      }`}
      aria-hidden
    >
      <div className="reading-cosmo-base" />
      <div className="reading-cosmo-nebula reading-cosmo-nebula--a" />
      <div className="reading-cosmo-nebula reading-cosmo-nebula--b" />
      <div className="reading-cosmo-stars" />
    </div>
  )
}
